<template>
    <v-app>
        <component v-bind:is="layout"></component>
    </v-app>
</template>

<script>
const default_layout = 'app'

export default {
    computed: {
        layout() {
            return (this.$route.meta.layout || default_layout) + '-layout'
        },
    },
    watch: {
        // Watch for authentication state changes
        '$auth.isAuthenticated': {
            handler(isAuthenticated) {
                if (isAuthenticated && this.$auth.user) {
                    // Update Sentry user context when user logs in
                    this.$store.dispatch(
                        'sentry/updateSentryUser',
                        this.$auth.user
                    )
                } else {
                    // Clear user context when user logs out
                    this.$store.dispatch('sentry/updateSentryUser', null)
                }
            },
            immediate: true,
        },
    },
    mounted() {
        // Initialize Sentry integration
        this.$store.dispatch('sentry/initializeSentry')

        // Set initial user context if already authenticated
        if (this.$auth.isAuthenticated && this.$auth.user) {
            this.$store.dispatch('sentry/updateSentryUser', this.$auth.user)
        }
    },
}
</script>
